export interface Profile {
    title: string;
    owner: string;
    ipfs: string;
    allow: string[];
    reserve: number;
    max: number;
}

export interface Metadata {
    name: string;
    description: string;
    artifactUri: string;
    generatorUri: string;
    iterationHash: string;
}

const SelectFirst = "Select Profile ...";
let profileNames = []
let profiles = {};

const clearProfile = () => {

}
const profilesSelect = document.getElementsByClassName('select-profile')[0] as HTMLSelectElement;
profilesSelect.onchange = (e) => {
  const value = profilesSelect.value;
  console.log('selected', value)
  if (value === SelectFirst) clearProfile();
  else loadProfile(value)
}
const reloadProfileSelect = () => {
  console.log('reload profiles')
  profilesSelect.innerText = null;
  const option = document.createElement("OPTION") as HTMLOptionElement;
  option.value = SelectFirst;
  option.text = SelectFirst;
  profilesSelect.add(option)
  for (let p of profileNames) {
    const option = document.createElement("OPTION") as HTMLOptionElement;
    option.value = p;
    option.text = p;
    profilesSelect.add(option)
  }
}

const loadProfiles = () => {
  if (profileNames.length > 0) return;
  let pnames = localStorage.getItem("profiles")
  if (pnames) {
    profileNames = JSON.parse(pnames);
    for (let profile of profileNames) {
      const p = localStorage.getItem(`profile-${profile}`)
      if (p) {
        profiles[profile] = JSON.parse(p)
        console.log('profile laoded', profiles[profile])
      }
    }
  }
  reloadProfileSelect();
}

loadProfiles();

let account = '';

export const getCurrentProfile = () => {
  const p = profilesSelect.value;
  return p === SelectFirst ? undefined : profiles[p]
}

const MAX_INROOM = 10;
const inputIpfs = document.getElementsByClassName('input-artwork')[0] as HTMLInputElement;
const inputAllow = document.getElementsByClassName('allow')[0] as HTMLTextAreaElement;
const inputReserves = document.getElementsByClassName('input-reserve')[0] as HTMLInputElement;
const inputMax = document.getElementsByClassName('input-max')[0] as HTMLInputElement;
const buttonSave = document.getElementsByClassName('button-save')[0] as HTMLButtonElement;
buttonSave.onclick = (e) => {
  const p = profilesSelect.value;
  if (p !== SelectFirst)
    saveProfile(p)
}
const saveProfile = async (title) => {
  let max = inputMax.valueAsNumber;
  if (max <= 2) max = 5;
  if (max >= MAX_INROOM) max = MAX_INROOM;
  let reserve = inputReserves.valueAsNumber;
  if (reserve > max)
    reserve = max;
  const allow = inputAllow.value.trim().split(/[\n\r\t ]+/).filter(s => s.length > 0);
  console.log('allow', allow)
  const nickname = '';
  const ipfs = inputIpfs.value;
  const profile: Profile = {
    title,
    owner: account,
    ipfs,
    allow,
    reserve,
    max,
  }
  if (!profileNames.includes(title)) {
    profileNames.push(title);
    profileNames.sort((a, b) => a - b)
    reloadProfileSelect();
    localStorage.setItem("profiles", JSON.stringify(profileNames))
  }
  console.log('profile', profile)
  profiles[title] = profile;
  localStorage.setItem(`profile-${title}`, JSON.stringify(profile))
}

const loadProfile = async (title) => {
  console.log('laodProfile', title)
  const p = profiles[title] as Profile
  console.log('laodProfile', title, p)
  inputMax.value = `${p.max}`
  inputReserves.value = `${p.reserve}`
  inputAllow.value = p.allow.join('\n');
  inputIpfs.value = p.ipfs
}
const buttonSaveAs = document.getElementsByClassName('button-saveas')[0] as HTMLButtonElement;
const inputSaveAs = document.getElementsByClassName('input-saveas')[0] as HTMLInputElement;
buttonSaveAs.onclick = (e) => {
  const p = inputSaveAs.value;
  if (p && p.length > 0)
    saveProfile(p);
}

export const ipfsPrefix = "https://gateway.fxhash2.xyz/ipfs";

export const nextFxhash = () => {
  const alphabet = "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
	return "oo" + Array(49).fill(0).map(_=>alphabet[(Math.random()*alphabet.length)|0]).join('')
}

export const getIpfsMetadata = async (hash: string): Promise<Metadata> => {
    try {
        const url = `${ipfsPrefix}/${hash}`;
        const res = await fetch(url);
        const json = await res.json();
        console.log('metadata', hash, json)
        return json as Metadata
    } catch (e) {
        console.log('getIpfsMetadata failed', e)
    }
}

export const getIpfsUrl = async (profile: Profile) => {
  const meta = await getIpfsMetadata(profile.ipfs)
  return getIpfsUrlFromMeta(meta);
}

export const getIpfsUrlFromMeta = async (meta: Metadata) => {
  const generator = meta.generatorUri || meta.artifactUri
  const base = `${ipfsPrefix}/${generator.substring(7)}/?fxhash=`;
  const hash = meta.iterationHash || nextFxhash()
  const url = `${base}${hash}`;
  return url;
}

export const setupCreator = (acc) => {
  console.log('setupCreator', acc)
  account = acc;
  loadProfiles();
}

export const setupCreatorLoaded = (acc) => {
  console.log('setupCreatorLoaded', acc)
  account = acc;
  const rem = document.getElementsByClassName('creator-loaded');
  for (let ele of rem) {
    let e = ele as HTMLElement;
    e.style.display = "none";
  }
}

export const setupViewer = (acc) => {
  console.log('setupViewer', acc)
  account = acc;
  const kick = document.getElementsByClassName('button-kick')[0] as HTMLDivElement;
  kick.style.display = "none";
  const creator = document.getElementsByClassName('creator')[0] as HTMLDivElement;
  creator.style.display = "none";
}
